import { IPropertyReturn, IPayment } from "../types/ownerDashboard.types";
import { normalizeKenloPropertyId } from "./buildPropertyLabelMap";
import { KenloPropertyOption, getKenloPropertyOptions } from "./getKenloPropertyOptions";

export function buildRegisterPropertyOptions(
  payments: IPayment[],
  propertyFilterOptions: KenloPropertyOption[],
  registeredPropertyReturns: IPropertyReturn[]
): KenloPropertyOption[] {
  const registeredKenloIds = registeredPropertyReturns.map((item) =>
    normalizeKenloPropertyId(item.kenlo_property_id)
  );

  const optionsById = new Map<string, KenloPropertyOption>();

  propertyFilterOptions.forEach((option) => {
    const kenloPropertyId = normalizeKenloPropertyId(option.kenloPropertyId);

    if (!kenloPropertyId || registeredKenloIds.includes(kenloPropertyId)) {
      return;
    }

    optionsById.set(kenloPropertyId, {
      kenloPropertyId,
      label: option.label,
    });
  });

  getKenloPropertyOptions(payments, registeredKenloIds).forEach((option) => {
    optionsById.set(option.kenloPropertyId, option);
  });

  return Array.from(optionsById.values()).sort((first, second) =>
    first.label.localeCompare(second.label, "pt-BR")
  );
}
